module.exports = "<button class=\"btn btn-default btn-lg\"\n        spinning-wheel [is-spinning-wheel-active]=\"isSpinnerActive\" [is-spinning-wheel-dark]=\"'true'\"\n        (click)=\"downloadLog()\">\n    <i class=\"fi fi-download-icon\"></i>Download Log\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/jobs/modals/download-log/download-log.html
// module id = ./web/modern/components/jobs/modals/download-log/download-log.html
// module chunks = 0